import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employer-home',
  templateUrl: './employer-home.component.html',
  styleUrls: ['./employer-home.component.css']
})
export class EmployerHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
